import {
  PSMS_CALLS_CHATS_DETAILS_REQUEST,
  PSMS_CALLS_CHATS_DETAILS_SUCCESS,
  PSMS_CALLS_CHATS_DETAILS_FAILURE,
  PSMS_CALLS_CHATS_DETAILS_LOADING,
  PSMS_CALLS_CHATS_TREND_REQUEST,
  PSMS_CALLS_CHATS_TREND_SUCCESS,
  PSMS_CALLS_CHATS_TREND_FAILURE,
  PSMS_CALLS_CHATS_TREND_LOADING,
} from '../actionTypes';

/**
 * Calls/Chats Details Actions
 */
export const fetchCallsChatsDetailsRequest = (payload?: any) => ({
  type: PSMS_CALLS_CHATS_DETAILS_REQUEST,
  payload,
});

export const fetchCallsChatsDetailsLoading = (loading: boolean) => ({
  type: PSMS_CALLS_CHATS_DETAILS_LOADING,
  payload: loading,
});

export const fetchCallsChatsDetailsSuccess = (payload: any) => ({
  type: PSMS_CALLS_CHATS_DETAILS_SUCCESS,
  payload,
});

export const fetchCallsChatsDetailsFailure = (error: string) => ({
  type: PSMS_CALLS_CHATS_DETAILS_FAILURE,
  payload: error,
});

/**
 * Calls/Chats Trend Actions
 */
export const fetchCallsChatsTrendRequest = (payload?: any) => ({
  type: PSMS_CALLS_CHATS_TREND_REQUEST,
  payload,
});

export const fetchCallsChatsTrendLoading = (loading: boolean) => ({
  type: PSMS_CALLS_CHATS_TREND_LOADING,
  payload: loading,
});

export const fetchCallsChatsTrendSuccess = (payload: any) => ({
  type: PSMS_CALLS_CHATS_TREND_SUCCESS,
  payload,
});

export const fetchCallsChatsTrendFailure = (error: string) => ({
  type: PSMS_CALLS_CHATS_TREND_FAILURE,
  payload: error,
});
